import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const TemplateEmptyState = ({ height = 190, width = 190, ...props }: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 190 190" {...props}>
    <path
      d="M76.5648 194.296C98.3909 203.694 123.056 204.037 145.135 195.249C167.214 186.461 184.897 169.262 194.295 147.436C203.693 125.61 204.036 100.945 195.248 78.8661C186.46 56.7873 169.261 39.1039 147.435 29.7059C125.609 20.3079 100.944 19.9652 78.8648 28.7532C56.7861 37.5412 39.1026 54.74 29.7047 76.5661C20.3067 98.3921 19.964 123.058 28.752 145.136C37.54 167.215 54.7387 184.898 76.5648 194.296Z"
      fill="#F5F4F4"
    />
    <path
      d="M69.96 182.948C69.96 183.876 73.4006 184.766 79.525 185.422C85.6493 186.078 93.9558 186.447 102.617 186.447C111.278 186.447 119.585 186.078 125.709 185.422C131.833 184.766 135.274 183.876 135.274 182.948C135.274 182.02 131.833 181.13 125.709 180.474C119.585 179.818 111.278 179.449 102.617 179.449C93.9558 179.449 85.6493 179.818 79.525 180.474C73.4006 181.13 69.96 182.02 69.96 182.948Z"
      fill="#EBD3F1"
    />
    <path
      d="M131.772 179.449C131.772 176.974 130.789 174.601 129.039 172.852C127.29 171.102 124.917 170.119 122.442 170.119H82.7944C80.3201 170.119 77.9471 171.102 76.1974 172.852C74.4478 174.601 73.4648 176.974 73.4648 179.449C73.4648 180.067 73.7104 180.661 74.1477 181.098C74.5849 181.536 75.178 181.782 75.7967 181.783H129.44C130.059 181.782 130.652 181.536 131.089 181.098C131.526 180.661 131.772 180.067 131.772 179.449Z"
      fill="white"
      stroke="#6A266D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M87.4541 163.121H117.779V170.119H87.4541V163.121Z"
      fill="white"
      stroke="#6A266D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M166.764 149.125H38.4678V151.457C38.4678 154.55 39.6966 157.517 41.884 159.704C44.0714 161.892 47.0381 163.121 50.1315 163.121H155.1C158.193 163.121 161.16 161.892 163.348 159.704C165.535 157.517 166.764 154.55 166.764 151.457V149.125Z"
      fill="white"
      stroke="#6A266D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M166.764 74.4798C166.764 72.9482 166.462 71.4316 165.876 70.0166C165.29 68.6017 164.431 67.316 163.347 66.2331C162.264 65.1502 160.979 64.2913 159.563 63.7054C158.148 63.1195 156.632 62.8181 155.1 62.8184H50.1315C47.0384 62.8184 44.0721 64.0469 41.8848 66.2338C39.6975 68.4207 38.4684 71.3868 38.4678 74.4798V149.126H166.764V74.4798Z"
      fill="#EBD3F1"
    />
    <path
      d="M166.764 74.4798C166.764 72.9482 166.462 71.4316 165.876 70.0166C165.29 68.6017 164.431 67.316 163.347 66.2331C162.264 65.1502 160.979 64.2913 159.563 63.7054C158.148 63.1195 156.632 62.8181 155.1 62.8184H50.1315C47.0384 62.8184 44.0721 64.0469 41.8848 66.2338C39.6975 68.4207 38.4684 71.3868 38.4678 74.4798V149.126H166.764V74.4798Z"
      stroke="#6A266D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <mask id="path-8-inside-1_1871_120879" fill="white">
      <path d="M102.616 155.904C102.661 155.904 102.704 155.917 102.741 155.942C102.778 155.966 102.806 156.001 102.823 156.042C102.84 156.083 102.845 156.128 102.836 156.172C102.827 156.215 102.806 156.255 102.775 156.286C102.743 156.318 102.703 156.339 102.66 156.348C102.617 156.356 102.572 156.352 102.531 156.335C102.49 156.318 102.455 156.289 102.43 156.253C102.405 156.216 102.392 156.172 102.392 156.128C102.392 156.069 102.416 156.012 102.458 155.97C102.5 155.928 102.557 155.904 102.616 155.904ZM102.616 153.664C102.129 153.664 101.653 153.809 101.247 154.079C100.842 154.35 100.526 154.735 100.34 155.185C100.153 155.635 100.105 156.131 100.2 156.609C100.295 157.087 100.529 157.526 100.874 157.87C101.219 158.215 101.658 158.45 102.136 158.545C102.614 158.64 103.109 158.591 103.559 158.405C104.01 158.218 104.394 157.902 104.665 157.497C104.936 157.092 105.08 156.615 105.08 156.128C105.08 155.475 104.821 154.848 104.359 154.386C103.897 153.924 103.27 153.664 102.616 153.664Z" />
    </mask>
    <path
      d="M102.616 155.904C102.661 155.904 102.704 155.917 102.741 155.942C102.778 155.966 102.806 156.001 102.823 156.042C102.84 156.083 102.845 156.128 102.836 156.172C102.827 156.215 102.806 156.255 102.775 156.286C102.743 156.318 102.703 156.339 102.66 156.348C102.617 156.356 102.572 156.352 102.531 156.335C102.49 156.318 102.455 156.289 102.43 156.253C102.405 156.216 102.392 156.172 102.392 156.128C102.392 156.069 102.416 156.012 102.458 155.97C102.5 155.928 102.557 155.904 102.616 155.904ZM102.616 153.664C102.129 153.664 101.653 153.809 101.247 154.079C100.842 154.35 100.526 154.735 100.34 155.185C100.153 155.635 100.105 156.131 100.2 156.609C100.295 157.087 100.529 157.526 100.874 157.87C101.219 158.215 101.658 158.45 102.136 158.545C102.614 158.64 103.109 158.591 103.559 158.405C104.01 158.218 104.394 157.902 104.665 157.497C104.936 157.092 105.08 156.615 105.08 156.128C105.08 155.475 104.821 154.848 104.359 154.386C103.897 153.924 103.27 153.664 102.616 153.664Z"
      fill="#6A266D"
    />
    <path
      d="M102.392 156.128H100.892H102.392ZM105.08 156.128H106.58H105.08ZM102.616 157.404C102.364 157.404 102.117 157.329 101.907 157.189L103.574 154.695C103.291 154.505 102.957 154.404 102.616 154.404V157.404ZM101.907 157.189C101.698 157.049 101.534 156.85 101.437 156.616L104.209 155.468C104.079 155.153 103.858 154.884 103.574 154.695L101.907 157.189ZM101.437 156.616C101.341 156.383 101.316 156.126 101.365 155.879L104.307 156.464C104.374 156.13 104.34 155.783 104.209 155.468L101.437 156.616ZM101.365 155.879C101.414 155.632 101.535 155.404 101.714 155.226L103.835 157.347C104.077 157.106 104.241 156.799 104.307 156.464L101.365 155.879ZM101.714 155.226C101.893 155.047 102.12 154.926 102.367 154.877L102.953 157.819C103.287 157.752 103.594 157.588 103.835 157.347L101.714 155.226ZM102.367 154.877C102.615 154.827 102.872 154.853 103.105 154.949L101.957 157.721C102.272 157.851 102.618 157.885 102.953 157.819L102.367 154.877ZM103.105 154.949C103.338 155.046 103.537 155.209 103.677 155.419L101.183 157.086C101.372 157.369 101.641 157.59 101.957 157.721L103.105 154.949ZM103.677 155.419C103.818 155.629 103.892 155.876 103.892 156.128H100.892C100.892 156.469 100.993 156.802 101.183 157.086L103.677 155.419ZM103.892 156.128C103.892 156.466 103.758 156.791 103.519 157.03L101.397 154.909C101.074 155.232 100.892 155.671 100.892 156.128H103.892ZM103.519 157.03C103.279 157.27 102.955 157.404 102.616 157.404V154.404C102.159 154.404 101.721 154.586 101.397 154.909L103.519 157.03ZM102.616 152.164C101.832 152.164 101.066 152.397 100.414 152.832L102.081 155.327C102.239 155.221 102.426 155.164 102.616 155.164V152.164ZM100.414 152.832C99.7622 153.268 99.2541 153.887 98.9541 154.611L101.726 155.759C101.799 155.583 101.922 155.432 102.081 155.327L100.414 152.832ZM98.9541 154.611C98.6541 155.335 98.5756 156.132 98.7285 156.901L101.671 156.316C101.634 156.129 101.653 155.935 101.726 155.759L98.9541 154.611ZM98.7285 156.901C98.8815 157.67 99.259 158.377 99.8134 158.931L101.935 156.81C101.8 156.675 101.708 156.503 101.671 156.316L98.7285 156.901ZM99.8134 158.931C100.368 159.485 101.074 159.863 101.843 160.016L102.428 157.074C102.241 157.036 102.07 156.945 101.935 156.81L99.8134 158.931ZM101.843 160.016C102.612 160.169 103.409 160.09 104.133 159.79L102.985 157.019C102.809 157.092 102.615 157.111 102.428 157.074L101.843 160.016ZM104.133 159.79C104.858 159.49 105.477 158.982 105.912 158.33L103.418 156.664C103.312 156.822 103.161 156.946 102.985 157.019L104.133 159.79ZM105.912 158.33C106.348 157.678 106.58 156.912 106.58 156.128H103.58C103.58 156.319 103.524 156.505 103.418 156.664L105.912 158.33ZM106.58 156.128C106.58 155.077 106.163 154.068 105.419 153.325L103.298 155.446C103.479 155.627 103.58 155.872 103.58 156.128H106.58ZM105.419 153.325C104.676 152.582 103.668 152.164 102.616 152.164V155.164C102.872 155.164 103.117 155.266 103.298 155.446L105.419 153.325Z"
      fill="#6A266D"
      mask="url(#path-8-inside-1_1871_120879)"
    />
    <path
      d="M187.756 129.53C187.752 131.014 187.161 132.436 186.112 133.485C185.062 134.535 183.64 135.126 182.156 135.13H72.0111C70.527 135.127 69.1047 134.535 68.0553 133.486C67.0058 132.437 66.4147 131.014 66.4111 129.53V58.8066H187.756V129.53Z"
      fill="white"
      stroke="#6A266D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M187.757 58.806H66.4141V45.0883C66.4176 43.6042 67.0088 42.1818 68.0582 41.1324C69.1076 40.083 70.5299 39.4918 72.0141 39.4883H182.159C183.643 39.4924 185.065 40.0837 186.115 41.1331C187.164 42.1824 187.755 43.6043 187.759 45.0883L187.757 58.806Z"
      fill="white"
      stroke="#6A266D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M72.8516 49.1486C72.8516 49.5713 72.9348 49.9898 73.0966 50.3804C73.2584 50.7709 73.4954 51.1258 73.7943 51.4247C74.0933 51.7236 74.4481 51.9607 74.8386 52.1224C75.2292 52.2842 75.6477 52.3674 76.0704 52.3674C76.4932 52.3674 76.9117 52.2842 77.3023 52.1224C77.6928 51.9607 78.0476 51.7236 78.3465 51.4247C78.6454 51.1258 78.8825 50.7709 79.0443 50.3804C79.2061 49.9898 79.2893 49.5713 79.2893 49.1486C79.2893 48.7259 79.2061 48.3073 79.0443 47.9168C78.8825 47.5262 78.6454 47.1714 78.3465 46.8725C78.0476 46.5736 77.6928 46.3365 77.3023 46.1747C76.9117 46.0129 76.4932 45.9297 76.0704 45.9297C75.6477 45.9297 75.2292 46.0129 74.8386 46.1747C74.4481 46.3365 74.0933 46.5736 73.7943 46.8725C73.4954 47.1714 73.2584 47.5262 73.0966 47.9168C72.9348 48.3073 72.8516 48.7259 72.8516 49.1486Z"
      fill="#EBD3F1"
      stroke="#6A266D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M85.7266 49.1486C85.7266 50.0023 86.0657 50.821 86.6693 51.4247C87.273 52.0283 88.0917 52.3674 88.9454 52.3674C89.7991 52.3674 90.6179 52.0283 91.2215 51.4247C91.8252 50.821 92.1643 50.0023 92.1643 49.1486C92.1643 48.2949 91.8252 47.4761 91.2215 46.8725C90.6179 46.2688 89.7991 45.9297 88.9454 45.9297C88.0917 45.9297 87.273 46.2688 86.6693 46.8725C86.0657 47.4761 85.7266 48.2949 85.7266 49.1486Z"
      fill="#EBD3F1"
      stroke="#6A266D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M98.6025 49.1486C98.6025 49.5713 98.6858 49.9898 98.8476 50.3804C99.0093 50.7709 99.2464 51.1258 99.5453 51.4247C99.8442 51.7236 100.199 51.9607 100.59 52.1224C100.98 52.2842 101.399 52.3674 101.821 52.3674C102.244 52.3674 102.663 52.2842 103.053 52.1224C103.444 51.9607 103.799 51.7236 104.098 51.4247C104.396 51.1258 104.634 50.7709 104.795 50.3804C104.957 49.9898 105.04 49.5713 105.04 49.1486C105.04 48.7259 104.957 48.3073 104.795 47.9168C104.634 47.5262 104.396 47.1714 104.098 46.8725C103.799 46.5736 103.444 46.3365 103.053 46.1747C102.663 46.0129 102.244 45.9297 101.821 45.9297C101.399 45.9297 100.98 46.0129 100.59 46.1747C100.199 46.3365 99.8442 46.5736 99.5453 46.8725C99.2464 47.1714 99.0093 47.5262 98.8476 47.9168C98.6858 48.3073 98.6025 48.7259 98.6025 49.1486Z"
      fill="#EBD3F1"
      stroke="#6A266D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M80.4561 67.4824H94.4516V81.4779H80.4561V67.4824Z"
      fill="white"
      stroke="#6A266D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M157.431 76.8143H101.449V72.1483C101.449 70.9109 101.941 69.7241 102.816 68.849C103.691 67.974 104.878 67.4824 106.115 67.4824H152.768C154.005 67.483 155.191 67.9749 156.065 68.8498C156.94 69.7248 157.431 70.9113 157.431 72.1483V76.8143Z"
      fill="white"
      stroke="#6A266D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M157.431 109.471C157.431 110.09 157.186 110.683 156.748 111.12C156.311 111.558 155.718 111.803 155.099 111.803H103.781C103.163 111.803 102.57 111.558 102.132 111.12C101.695 110.683 101.449 110.09 101.449 109.471V76.8145H157.431V109.471Z"
      fill="white"
      stroke="#6A266D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M101.449 76.8145L156.569 111.263"
      stroke="#6A266D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M102.301 111.272L157.432 76.8145"
      stroke="#6A266D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M80.4561 90.8105H94.4516"
      stroke="#6A266D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M80.4561 100.139H94.4516"
      stroke="#6A266D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M80.4561 109.471H94.4516"
      stroke="#6A266D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M164.43 67.4824H178.425V90.8098H164.43V67.4824Z"
      fill="white"
      stroke="#6A266D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M164.43 97.8066H178.425V121.134H164.43V97.8066Z"
      fill="white"
      stroke="#6A266D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M117.777 123.467H155.1"
      stroke="#6A266D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
